document.addEventListener('alpine:init', () => {
    const DATA_POINTS = document.getElementById('ql-data-points')

    Alpine.data('invite_team_member_x_data', () => ({
        all_permissions: JSON.parse(DATA_POINTS.dataset.allPermissions),
        filtered_shows: [],
        search_term: '',
        show_dropdown: false,
        selected_all_permissions: false,
        search_results: [],
        show_result_dropdown: false,
        add_member_data: {
            owner_email: '',
            selected_shows: [],
            selected_permissions: []
        },
        init() {
            this.$watch('selected_all_permissions', val => {
                if (val) {
                    this.all_permissions.forEach(permission => this.add_member_data.selected_permissions.push(permission.name))
                } else {
                    this.add_member_data.selected_permissions = []
                }
            })
        },
        filter_shows(event) {
            const lookupShowUrl = DATA_POINTS.dataset.lookupShowUrl
            const search_data = event.target.value
            if (search_data.length < 2) {
                this.filtered_shows = []
                return
            }
            fetch(lookupShowUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
                },
                body: JSON.stringify({search_data})
            }).then(response => response.json())
                .then(data => {
                    this.filtered_shows = this.filter_selected_shows(data.shows)
                    this.show_dropdown = true
                })
        },
        filter_selected_shows(shows) {
            return shows.filter(show => !this.add_member_data.selected_shows.some(selected => selected.id === show.id))
        },
        add_show(show) {
            const showIndex = this.add_member_data.selected_shows.findIndex(s => s.id === show.id);

            if (showIndex === -1) {
                // Add show to selected shows
                this.add_member_data.selected_shows.push(show);
            }
            this.show_dropdown = false
            this.search_term = ''
            this.filtered_shows = []
        },
        remove_show(show) {
            this.add_member_data.selected_shows = this.add_member_data.selected_shows.filter(selected => selected.id !== show.id);
        },
        handle_permission_select(permission) {
            if (this.add_member_data.selected_permissions.includes(permission.name)) {
                this.add_member_data.selected_permissions = this.add_member_data.selected_permissions.filter(selected => selected !== permission.name)
            } else {
                this.add_member_data.selected_permissions.push(permission.name)
            }
        },
        close_dropdown() {
            setTimeout(() => {
                this.show_dropdown = false
                this.search_term = ''
            }, 200)
        },
        select_user(email) {
            this.add_member_data.owner_email = email
            this.show_result_dropdown = false
        },
        fetch_user_data(event) {
            const url = DATA_POINTS.dataset.lookupUserUrl
            const search_data = event.target.value
            if (search_data.length < 2) {
                this.search_results = []
                return
            }
            fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
                },
                body: JSON.stringify({search_data})
            }).then(response => response.json())
                .then(data => {
                    this.search_results = data.users
                    this.show_result_dropdown = true
                })
        },
        send_invite() {
            const invite_url = DATA_POINTS.dataset.sendInvitesUrl

            console.log(this.add_member_data)

            console.log(invite_url)

            if (!this.add_member_data.owner_email) {
                alert('Please enter a valid email address')
                return
            }

            // Invalid email address
            if (!this.add_member_data.owner_email.includes('@')) {
                alert('Please enter a valid email address')
                return
            }

            if (this.add_member_data.selected_shows.length === 0) {
                alert('Please select at least one show')
                return
            }

            if (this.add_member_data.selected_permissions.length === 0) {
                alert('Please select at least one permission')
                return
            }

            fetch(invite_url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
                },
                body: JSON.stringify(this.add_member_data)
            }).then(response => response.json())
                .then(data => {
                    if (data.success) {
                        alert('Invite sent successfully')
                        window.location.reload()
                    } else if (data.error) {
                        alert(data.error)
                    }
                })
        }
    }))
})